import React, { useState, useEffect } from 'react';
import useFirebase from '../../../../../useFirebase';
import { useSelector, useDispatch } from 'react-redux';
import {
    setTimeSupervision
} from '../../../AxiosRtk/SetRules';
// import {
//     setRulesDataApi,
//     setRulesData
// } from '../../../AxiosRtk/DashBoard';
import { useHistory } from 'react-router-dom';
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import useLangTranslation from '../../../../customHooks/languageProvider';
import { setShowMessage } from '../../../AxiosRtk/successMessage';

const TimeSupervision = ({ deviceSelected }) => {
    const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);
    const dispatch = useDispatch();
    const history = useHistory();
    const [toggle, setToggle] = useState({ timesupervision: 0, webapp: 0, allowMonitor: 0 })
    const [timeSupervisionData, setTimeSupervisionData] = useState(null);
    const { setRulesData } = useSelector(({ setRules }) => setRules);
    const { selectedKidId, selectedDeviceData } = useSelector(({ dashboard }) => dashboard);
    const { getLangTranslation } = useLangTranslation();
    // console.log("selectedDeviceData ==>>", JSON.parse(selectedDeviceData)?.ID)
    // console.log(setRulesData?.timesupervison);
    // console.log("timeSupervisionData ==>>", timeSupervisionData)
    // console.log("toggle ==>>", toggle)

    // console.log(setRulesData)

    const {
        postCollectionData,
        getCollectionData,
        createCollectionData
    } = useFirebase();

    function callFirebase(payload) {
        if (setRulesData) {
            postCollectionData(deviceSelected, payload)
        } else {
            createCollectionData(deviceSelected, payload)
        }
        getCollectionData(deviceSelected);

        setTimeout(() => {
            dispatch(setShowMessage({
                showMessage: true,
                message: "KEYSTROKE_STATUS_UPDATED",
                defaultMessage: "Changes successfully updated"
            }))
        }, 1000);
    }

    function settingSetRulesDataIntoSqlDb(payload) {
        setTimeSupervision(payload)
            .then(() => {

            })
            .catch((err) => {
                console.log("set time supervision catch error ==>>", err?.response?.data?.message)
            })
    }

    useEffect(() => {
        if (deviceSelected) {
            getCollectionData(deviceSelected);
        } else {
            dispatch(setRuleDataSetUp(null));
        }
    }, [deviceSelected])

    useEffect(() => {
        if (setRulesData?.timesupervison) {
            setTimeSupervisionData(setRulesData?.timesupervison ?? 0);

            setToggle({
                ...toggle,
                timesupervision: setRulesData?.timesupervison?.isDeviceTimeSupervisionEnabled
            })
        } else {
            setTimeSupervisionData(null);
            setToggle({
                timesupervision: 0,
                webapp: 0,
                allowMonitor: 0
            })
        }
    }, [setRulesData])

    async function handleToggleChange(e) {
        const { name, checked } = e.target;

        if(name !== 'DEVICE_TIME_SUPERVISION' && !checked) {
            return;
        }

        const payload = {
            kidId: selectedKidId,
            deviceId: JSON.parse(selectedDeviceData?.ID),
            is_load_default_settings: 0,
            AllowedApps: [],
            AllowedContacts: [],
            DailyLimit: {},
            Schedule: [],
            dailyLimitSeekBarProgress: 0
        }

        let collectionPayload = null

        if (name === 'DEVICE_TIME_SUPERVISION') {
            // setTimeSupervision()
            collectionPayload = {
                setRulesActiveInActiveStatus: {
                    ...setRulesData?.setRulesActiveInActiveStatus,
                    timeSupervisionEnabled: checked
                },
                timesupervison: {
                    ...timeSupervisionData,
                    isDeviceTimeSupervisionEnabled: checked ? 1 : 0,
                    isBlockWebAndAppEnabled: 0,
                    isAllowAndMonitorParentsEnabled: checked ? 1 : 0,
                    isWarnKidByAlertEnabled: 0
                }
            }

            payload['IsDeviceTimeSupervisionEnabled'] = checked ? 1 : 0
            payload['IsBlockWebAndAppEnabled'] = 0
            payload['IsWarnKidByAlertEnabled'] = 0
            payload['IsAllowAndMonitorParentsEnabled'] = 1
        } else if (name === 'BLOCK_WEB_APP') {
            collectionPayload = {
                timesupervison: {
                    ...timeSupervisionData,
                    isBlockWebAndAppEnabled: checked ? 1 : 0,
                    isAllowAndMonitorParentsEnabled: 0,
                    isWarnKidByAlertEnabled: 0
                }
            }

            payload['IsBlockWebAndAppEnabled'] = checked ? 1 : 0
            payload['IsWarnKidByAlertEnabled'] = 0
            payload['IsAllowAndMonitorParentsEnabled'] = 0
        } else if (name === 'ALLOW_MONITOR') {
            collectionPayload = {
                timesupervison: {
                    ...timeSupervisionData,
                    isAllowAndMonitorParentsEnabled: checked ? 1 : 0,
                    isBlockWebAndAppEnabled: 0,
                    isWarnKidByAlertEnabled: 0
                }
            }
            payload['IsBlockWebAndAppEnabled'] = 0
            payload['IsWarnKidByAlertEnabled'] = 0
            payload['IsAllowAndMonitorParentsEnabled'] = checked ? 1 : 0
        } else if (name === 'ALLOW_WARN_CHILD') {
            collectionPayload = {
                timesupervison: {
                    ...timeSupervisionData,
                    isWarnKidByAlertEnabled: checked ? 1 : 0,
                    isAllowAndMonitorParentsEnabled: 0,
                    isBlockWebAndAppEnabled: 0
                }
            }

            payload['IsBlockWebAndAppEnabled'] = 0
            payload['IsWarnKidByAlertEnabled'] = checked ? 1 : 0
            payload['IsAllowAndMonitorParentsEnabled'] = 0
        }

        callFirebase(collectionPayload);
        // await getSetRulesDataFirebase();
        // console.log("payload ==>>", payload)

        settingSetRulesDataIntoSqlDb(payload);
    }

    function handleMoveRoutes(route) {
        if (timeSupervisionData?.isAllowAndMonitorParentsEnabled) {
            return true;
        }

        if (route === 'SET_DAILY_LIMIT') {
            history.push("/set-daily-limit")
        } else if (route === 'SET_SCHEDULE') {
            history.push("/set-rules/set-schedule")
        }
    }

    if (!deviceSelected) {
        return (<div className='text-center my-3'>
            -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
        </div>)
    }

    return (
        <>
            {/* <button className='btn btn-primary' onClick={() => handleHit()}>hit</button> */}
            {/* <div className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold" role="alert">
                <i className='icon-info-one fs-5' />
                {getLangTranslation("YOU_CAN_SET_DEVICE_USE_TIME_LIMIT_SCHEDULE", "Here, you can set device use time limits and schedules for your child.")}
                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div> */}
            <div className="form-check form-switch mb-6">
                <input
                    className="form-check-input"
                    id='One'
                    type="checkbox"
                    role="switch"
                    name="DEVICE_TIME_SUPERVISION"
                    checked={timeSupervisionData?.isDeviceTimeSupervisionEnabled ?? 0}
                    onChange={handleToggleChange}
                />
                <label className="form-check-label text-blue-800 fw-semibold" htmlFor="One">
                    {getLangTranslation("TIME_SUPERVISION_DEVICE_TIME_SUPERVISION_ENABLE", "Device time supervision")}
                </label>
            </div>
            {
                timeSupervisionData?.isDeviceTimeSupervisionEnabled === 1 && (
                    <>
                        <div className="form-check form-switch mb-6">
                            <input
                                className="form-check-input"
                                id='Two'
                                type="checkbox"
                                role="switch"
                                name="BLOCK_WEB_APP"
                                checked={timeSupervisionData?.isBlockWebAndAppEnabled ?? 0}
                                onChange={handleToggleChange}
                            />
                            <label className="form-check-label text-dark" htmlFor="Two">
                                {getLangTranslation("TIME_SUPERVISION_BLOCK_WEB_APPS", "Block web & apps")}
                            </label>
                        </div>
                        <div className="form-check form-switch mb-6">
                            <input
                                className="form-check-input"
                                id='Four'
                                type="checkbox"
                                role="switch"
                                name="ALLOW_WARN_CHILD"
                                checked={timeSupervisionData?.isWarnKidByAlertEnabled ?? 0}
                                onChange={handleToggleChange}
                            />
                            <label className="form-check-label text-dark" htmlFor="Four">
                                {getLangTranslation("TIME_SUPERVISION_ALLOW_AND_WARN_THE_CHILD", "Allow and warn the child")}
                            </label>
                        </div>
                        <div className="form-check form-switch mb-9">
                            <input
                                className="form-check-input"
                                id='Three'
                                type="checkbox"
                                role="switch"
                                name="ALLOW_MONITOR"
                                checked={timeSupervisionData?.isAllowAndMonitorParentsEnabled ?? 0}
                                onChange={handleToggleChange}
                            />
                            <label className="form-check-label text-dark" htmlFor="Three">
                                {getLangTranslation("TIME_SUPERVISION_ALLOW_AND_MONITOR_THE_CHILD", "Allow and monitor")}
                            </label>
                        </div>
                        

                        <div className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold" role="alert">
                            <i className='icon-info fs-5' />
                            {getLangTranslation("TIME_SUPERVISION_SET_RULE_DESC", "Important: If you enable the schedule, the daily limit will not work, as schedule will have priority.")}
                            {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> */}
                        </div>
                        <div className='grid gap-3'>
                            <div
                                className='g-col-12 g-col-lg-3'
                                onClick={() => handleMoveRoutes('SET_DAILY_LIMIT')}
                            >
                                <div className={`d-flex align-items-center justify-content-center p-6 ${timeSupervisionData?.isAllowAndMonitorParentsEnabled ? 'text-gray' : 'text-blue-400 pt-cursor'} border rounded-3 bg-gray-300 h-100`} >
                                    <span className='text-uppercase fw-bold'>{getLangTranslation("TIME_SUPERVISION_SET_DAILY_LIMIT", "Set a daily limit")}</span>
                                    <i className={`fs-5 ${lang?.isRTL === 1 ? 'icon-arrow-left' : 'icon-arrow-right'}`} />
                                </div>
                            </div>
                            <div
                                className='g-col-12 g-col-lg-3'
                                onClick={() => handleMoveRoutes('SET_SCHEDULE')}
                            >
                                <div className={`d-flex align-items-center justify-content-center p-6 ${timeSupervisionData?.isAllowAndMonitorParentsEnabled ? 'text-gray' : 'text-blue-400 pt-cursor'} border rounded-3 bg-gray-300 h-100`} >
                                    <span className='text-uppercase fw-bold'>{getLangTranslation("TIME_SUPERVISION_SET_A_SCHEDULE", "Set a schedule")}</span>
                                    <i className={`fs-5 ${lang?.isRTL === 1 ? 'icon-arrow-left' : 'icon-arrow-right'}`} />
                                </div>
                            </div>
                            <div className='g-col-12 g-col-lg-6'>
                                <div
                                    className={`d-flex align-items-center justify-content-center text-blue-400 pt-cursor flex-wrap p-6 border rounded-3 bg-gray-300 h-100 gap-3`}
                                    onClick={() => history.push("/set-rules/time-supervision-allow-apps")}
                                >
                                    <div className='d-flex flex-column'>
                                        <span
                                            className='text-uppercase fw-bold d-flex align-items-center'
                                        >{getLangTranslation("SET_ALLOWED_APPS_AND_CONTACTS", "Set allowed apps and contacts in time of block")}
                                            <i className={`fs-5 ${lang?.isRTL === 1 ? 'icon-arrow-left' : 'icon-arrow-right'}`} />
                                        </span>
                                        <p className={`w-100 text-dark fw-semibold mb-0`}>{getLangTranslation("FOR_SCREEN_TIME_TASK_BLOCK_TIMES", "(for screen time & tasks block times)")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
        </>
    )
}

export default TimeSupervision